export default function ({ user, countries }: any) {
  const country = (user.attributes && user.attributes["custom:country"]) || "",
    plusCode =
      countries.find((val: any) => val.id === country)?.plusPhoneCode || "",
    phone = user?.attributes?.phone_number?.replace(plusCode, "") || "";

  return { country, phone };
}
